import classnames from "classnames";
import React, { type ReactNode } from "react";

export const DetailsItemList = ({
  className,
  children,
}: {
  className?: string;
  children?: ReactNode;
}) => {
  return (
    <ul
      className={classnames(
        "m-0 list-none overflow-hidden",
        "[&_li]:relative [&_li]:mb-3 [&_li]:before:content-[''] [&_li]:before:absolute [&_li]:before:left-0 [&_li]:before:top-0 [&_li]:before:block [&_li]:before:font-medium",
        "[&_ul]:my-2 [&_ul_li]:pl-6 [&_ul_li]:before:content-['']",
        "[&_ul_ul_li]:pl-[30px] [&_ul_ul_li]:before:content-['']",
        "[&_a]:text-primary [&_a]:underline [&_a]:hover:no-underline [&_a]:focus:text-primary",
        "[&_.requests-indicator]:inline-block [&_.requests-indicator]:relative [&_.requests-indicator]:top-0.5 [&_.requests-indicator]:mx-0.5",
        className,
      )}
    >
      {children}
    </ul>
  );
};
